export default __webpack_public_path__ + "static/media/Q12024.7b00150e.pdf";